export enum Countries {
  PE = "pe",
  EC = "ec",
  CL = "cl",
  MX = "mx",
  CO = "co",
  DO = "do",
  PA = "pa",
  SV = "sv",
  BO = "bo",
  CR = "cr",
  PR = "pr",
  GT = "gt",
}
